import { Gauge } from "lucide-react";

import type {
  MeasurementToolsetRailController,
  ViewportToolsetRailRendererResult,
} from "@/viewport-tools/rail/types";
import { MEASUREMENT_TOOLSET, getMeasurementToolDefinition } from "./registry";
import { MeasurementToolsetPanel } from "@/viewport-tools/measurement/rail-panel";

export function renderMeasurementToolsetRail(
  controller: MeasurementToolsetRailController
): ViewportToolsetRailRendererResult {
  const activeExtraTool = controller.extraTools?.find(
    (tool) => tool.id === controller.activeExtraToolId
  );
  const activeSublabel = controller.activeTool
    ? `${getMeasurementToolDefinition(controller.activeTool).label}${controller.activeMeasurementType ? ` ${controller.activeMeasurementType}` : ""}`
    : activeExtraTool?.label;
  const hasScaleIndependentTools = (controller.extraTools?.length ?? 0) > 0;

  return {
    item: {
      id: MEASUREMENT_TOOLSET.id,
      icon: <Gauge className="size-4" />,
      label: MEASUREMENT_TOOLSET.label,
      sublabel: activeSublabel,
      active: !!controller.activeTool || !!activeExtraTool,
      selected: controller.expanded,
      disabled: !controller.scale && !hasScaleIndependentTools,
      onClick: () => controller.setExpanded(!controller.expanded),
      showExpandedIndicator: controller.expanded,
    },
    inlineContent:
      (controller.scale || hasScaleIndependentTools) && controller.expanded ? (
        <MeasurementToolsetPanel
          measurementTools={controller.measurementTools}
          measurementToolsDisabled={controller.measurementToolsDisabled}
          extraTools={controller.extraTools}
          activeTool={controller.activeTool}
          activeExtraToolId={controller.activeExtraToolId}
          activeMeasurementType={controller.activeMeasurementType}
          onToolSelect={controller.selectTool}
          onExtraToolSelect={controller.selectExtraTool}
          onTypeSelect={controller.selectMeasurementType}
          snapEnabled={controller.snapEnabled}
          onSnapToggle={controller.toggleSnap}
          snapAvailable={controller.snapAvailable}
          angleLockEnabled={controller.angleLockEnabled}
          onAngleLockToggle={controller.toggleAngleLock}
          incrementSnapEnabled={controller.incrementSnapEnabled}
          onIncrementSnapToggle={controller.toggleIncrementSnap}
          incrementStepFeet={controller.incrementStepFeet}
          onIncrementStepChange={controller.setIncrementStepFeet}
          showHeightInput={controller.showHeightInput}
          heightValue={controller.heightValue}
          onHeightChange={controller.setHeightValue}
          textLocked={controller.textLocked}
          onTextLockToggle={controller.toggleTextLock}
          textFontSize={controller.textFontSize}
          onTextFontSizeChange={controller.setTextFontSize}
          labelsVisible={controller.labelsVisible}
          onLabelsVisibleToggle={controller.toggleLabelsVisible}
        />
      ) : null,
  };
}
